
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_60991_44678)"}},[_c('path',{attrs:{"d":"M8 12a1.5 1.5 0 011.5-1.5h2.888a1.5 1.5 0 001.463-1.166c.103-.454.153-.92.149-1.386C13.972 4.647 11.24 1.967 7.937 2A6 6 0 002 8c0 2.613 1.67 4.59 4 5.413A1.5 1.5 0 008 12z","stroke":"currentColor","stroke-width":"1.25","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M8 5.5A.75.75 0 108 4a.75.75 0 000 1.5zM5.25 7a.75.75 0 100-1.5.75.75 0 000 1.5zM5.25 10.5a.75.75 0 100-1.5.75.75 0 000 1.5zM10.75 7a.75.75 0 100-1.5.75.75 0 000 1.5z","fill":"currentColor"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_60991_44678"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    